// extracted by mini-css-extract-plugin
export default {"container":"leK7F8","content":"Iz3uO4","left":"G8Qtqb","right":"QPijdb","open":"xeQIMo","closing":"P4q2QL"};